import { lighten, darken, OPA_10, OPA_20, OPA_30, OPA_50 } from '../themeUtils.js';

// Fixed light-theme colours from lv_theme_hasp.c (IS_LIGHT = true)
const SCR        = '#ffffff'; // COLOR_SCR light = LV_COLOR_WHITE
const SCR_GRAD   = '#c0c0c0'; // COLOR_SCR_GRAD light = LV_COLOR_SILVER
const SCR_TEXT   = '#3b3e42'; // COLOR_SCR_TEXT light
const BORDER     = '#404040'; // BORDER_COLOR light
const BTN_BORDER_CHK = '#3b3e42';
// const BTN_BORDER_DIS = '#888888'; // unused
const TEXT_DEFAULT   = '#eeeeee';
const TEXT_PR        = '#ffffff';
const TEXT_CHK       = '#ffffff';
const TEXT_DIS       = '#aaaaaa'; // COLOR_BG_TEXT_DIS light
const BTN_DIS        = '#cccccc'; // COLOR_BTN_DIS light

export function buildContext(primary, secondary) {
    const btnBg      = lighten(primary,  OPA_30);
    const btnPr      = lighten(primary,  OPA_10);
    const btnChk     = secondary;
    const btnChkPr   = darken(secondary, OPA_20);
    const btnBorder  = darken(primary,   OPA_50);  // light: darken instead of lighten
    const indic      = lighten(primary,  OPA_30);
    // const indicGrad  = darken(primary,   OPA_30); // unused

    const pretty = {
        bg_color:     SCR,
        bg_opa:       255,
        border_color: BORDER,
        border_width: 2,
        text_color:   SCR_TEXT,
    };

    const btnStyle = {
        bg_color:     btnBg,
        bg_opa:       255,
        border_color: btnBorder,
        border_width: 2,
        text_color:   TEXT_DEFAULT,
        states: {
            checked:          { bg_color: btnChk,   border_color: BTN_BORDER_CHK, text_color: TEXT_CHK },
            pressed:          { bg_color: btnPr,    border_color: BTN_BORDER_CHK, text_color: TEXT_PR  },
            pressedChecked:   { bg_color: btnChkPr, text_color: TEXT_CHK },
            disabled:         { text_color: TEXT_DIS },
            disabledChecked:  { bg_color: BTN_DIS,  text_color: TEXT_DIS },
        },
    };

    return {
        primary,
        secondary,
        SCR,
        SCR_GRAD,
        SCR_TEXT,
        BORDER,
        BTN_BORDER_CHK,
        TEXT_DEFAULT,
        TEXT_PR,
        TEXT_CHK,
        TEXT_DIS,
        BTN_DIS,
        btnBg,
        btnPr,
        btnChk,
        btnChkPr,
        btnBorder,
        indic,
        pretty,
        btnStyle,
    };
}
